import * as React from 'react';
import Add from '@youlify/icons/Add';
import Minus from '@youlify/icons/Minus';
import classNames from 'classnames';

import type { AnyObject } from '../_util/type';
import type { TableLocale } from './interface';

interface DefaultExpandIconProps<RecordType = AnyObject> {
  prefixCls: string;
  record: RecordType;
  expanded: boolean;
  expandable: boolean;
  onExpand: (record: RecordType, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function renderExpandIcon(locale: TableLocale) {
  return <RecordType extends AnyObject = AnyObject>(props: DefaultExpandIconProps<RecordType>) => {
    const { prefixCls, onExpand, record, expanded, expandable } = props;
    const iconPrefix = `${prefixCls}-row-expand-icon`;
    return (
      <button
        type="button"
        onClick={(e) => {
          onExpand(record, e!);
          e.stopPropagation();
        }}
        className={classNames(iconPrefix, {
          [`${iconPrefix}-spaced`]: !expandable,
          [`${iconPrefix}-expanded`]: expandable && expanded,
          [`${iconPrefix}-collapsed`]: expandable && !expanded,
        })}
        aria-label={expanded ? locale.collapse : locale.expand}
        aria-expanded={expanded}
      >
        {expandable && (expanded ? <Minus aria-hidden /> : <Add aria-hidden />)}
      </button>
    );
  };
}

export default renderExpandIcon;
